/** CUSTOM GLOBAL JS **/
require('./global');

/** CUSTOM JS **/
// require('./usage/usage');
// require('./changes/changes');
// require('./settings/settings');
// require('./contracts/contracts');
// require('./invoices/invoices');
// require('./salesperson/salesperson');
// require('./auth/delete-account');
// require('./admin/admin');
// require('./debug');
